import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/agents');
export const listProposalHistoryByCase = (caseId) => req('GET', `/proposals?caseId=${encodeURIComponent(caseId)}&includeHistory=true`);
export const listProposalsByCase = async (caseId) => {
    // Tolerate the pre-rollout response shape ({ proposals: [...] }) during
    // rolling deploys where the API is older than the webapp bundle.
    const res = await req('GET', `/proposals?caseId=${encodeURIComponent(caseId)}`);
    if (Array.isArray(res)) {
        return res;
    }
    if (res != null && Array.isArray(res.proposals)) {
        return res.proposals;
    }
    return [];
};
export const approveProposal = (proposalId, edits = null) => req('POST', `/proposals/${proposalId}/approve`, {
    body: edits ? { edits } : {},
});
export const retryProposal = (proposalId, edits = null) => req('POST', `/proposals/${proposalId}/retry`, {
    body: edits ? { edits } : {},
});
export const dismissFailedProposal = (proposalId) => req('POST', `/proposals/${proposalId}/dismiss`, { body: {} });
export const rejectProposal = (proposalId, reason = null) => req('POST', `/proposals/${proposalId}/reject`, {
    body: reason != null ? { reason } : {},
});
export const getPerformance = (period, filter) => req('GET', `/performance?${toQuery({
    ...period,
    toolName: filter.toolName ?? undefined,
    taskPromptKey: filter.taskPromptKey ?? undefined,
})}`);
// `includedKey` is listed even if it didn't run in the period.
export const listPerformanceTaskPrompts = (period, includedKey) => req('GET', `/performance/task-prompts?${toQuery({
    ...period,
    taskPromptKey: includedKey ?? undefined,
})}`);
export const listPerformanceProposals = (period, filter) => req('GET', `/performance/proposals?${toQuery({
    ...period,
    toolName: filter.toolName ?? undefined,
    decision: filter.decision ?? undefined,
    taskPromptKey: filter.taskPromptKey ?? undefined,
})}`);
export const previewInteractionProposal = (proposalId, edits = null) => req('POST', `/proposals/${proposalId}/preview-interaction`, {
    body: edits ? { edits } : {},
});
export const listAgentNoticesByCase = (caseId) => req('GET', `/notices?caseId=${encodeURIComponent(caseId)}`);
export const dismissAgentNotice = (noticeId) => req('POST', `/notices/${noticeId}/dismiss`, { body: {} });
//# sourceMappingURL=agents.js.map